import { Country } from '@superbet-group/web.types';
import {
    Config,
    OutcomeAllowance,
    OutcomeConfig,
} from '../types';
import {
    createAllowancesKey,
    mergeToExistingAllowances,
} from '../utils';

export function mapOutcomePairsToOutcomeAllowances(
    config: Config,
    target: Country,
): Record<string, Set<OutcomeAllowance>> {
    const pairs: Record<string, Set<OutcomeAllowance>> = {};
    Object.values(config).forEach((sportConfig) => {
        if (
            (!sportConfig.omitInTargets
            || !sportConfig.omitInTargets.includes(target))
            && sportConfig.outcomes
        ) {
            const outcomesById = sportConfig.outcomes.reduce((acc, outcome) => {
                acc[outcome.outcomeId] = outcome;
                return acc;
            }, {} as Record<number, OutcomeConfig>);
            Object.values(outcomesById).forEach((currentOutcome) => {
                const outcomesAllowedWithCurrentOutcome = new Set<OutcomeAllowance>();
                currentOutcome.outcomeAllowances?.forEach((allowance) => {
                    if (!allowance.omitInTargets || !allowance.omitInTargets.includes(target)) {
                        outcomesAllowedWithCurrentOutcome.add(allowance);
                    }
                });

                outcomesAllowedWithCurrentOutcome.forEach((allowedOutcome) => {
                    const key = createAllowancesKey(currentOutcome.outcomeId, allowedOutcome.outcomeId);
                    pairs[key] = mergeToExistingAllowances(pairs, [allowedOutcome], key);
                });
            });
        }
    });
    return pairs;
}
